import { Box, Card, CardContent, CardMedia } from "@mui/material";
import { ProfileData } from "../common/types";
import VerifiedIcon from "@mui/icons-material/Verified";
import "./Profile.css";
import { SyntheticEvent } from "react";
import placeholder from "./../assets/fallback-profile-image.svg";

interface ProfileProps {
  profile: ProfileData;
}

function Profile({ profile }: ProfileProps) {
  const { picture_url, full_name, occupation } = profile;
  const handleImageError = (e: SyntheticEvent) => {
    (e.target as HTMLInputElement).src = placeholder;
  };
  return (
    <>
      <Card sx={{ display: "flex" }} className="wlb-profile">
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <CardMedia
            component="img"
            className="wlb-profile-image"
            sx={{ width: 48, height: 48 }}
            image={picture_url}
            alt={`${full_name} profile image`}
            onError={handleImageError}
          />
        </Box>
        <Box>
          <CardContent className="wlb-profile-info">
            <div className="wlb-profile-title">
              {full_name}{" "}
              <VerifiedIcon sx={{ width: 16, height: 16, color: "#642CFF" }} />
            </div>
            <span className="wlb-profile-subtitle">{occupation}</span>
          </CardContent>
        </Box>
      </Card>
    </>
  );
}

export default Profile;
